import { useEffect } from "react";

const SITE_URL = "https://www.oguzhanozcelik.com";
const DEFAULT_OG = `${SITE_URL}/og-cover.jpg`;

function upsertMeta(attr, key, value) {
  if (!value) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
}

function upsertLink(rel, href) {
  if (!href) return;
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

function setJsonLd(id, data) {
  if (!data) return;
  let script = document.getElementById(id);
  if (!script) {
    script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = id;
    document.head.appendChild(script);
  }
  script.text = JSON.stringify(data);
}

export default function useSEO({
  title,
  description,
  path = "/",
  image = DEFAULT_OG,
  type = "website",
  jsonLd,
  jsonLdId = "page-jsonld",
}) {
  useEffect(() => {
    const fullUrl = `${SITE_URL}${path}`;
    if (title) document.title = title;

    upsertMeta("name", "description", description);
    upsertLink("canonical", fullUrl);

    upsertMeta("property", "og:type", type);
    upsertMeta("property", "og:title", title);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:url", fullUrl);
    upsertMeta("property", "og:image", image);

    upsertMeta("name", "twitter:title", title);
    upsertMeta("name", "twitter:description", description);
    upsertMeta("name", "twitter:image", image);

    if (jsonLd) setJsonLd(jsonLdId, jsonLd);
  }, [title, description, path, image, type, jsonLd, jsonLdId]);
}

export { SITE_URL };
